import { render, staticRenderFns } from "./createPerfil.vue?vue&type=template&id=ce54539a&scoped=true&"
import script from "./createPerfil.vue?vue&type=script&lang=js&"
export * from "./createPerfil.vue?vue&type=script&lang=js&"
import style0 from "./createPerfil.vue?vue&type=style&index=0&id=ce54539a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce54539a",
  null
  
)

export default component.exports